export const FAQS_I18N_ENTRIES = {
  faqs_Data1: {
    es: '<p>Preguntas frecuentes</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_Data2: {
    es: '<p>Volver</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data3: {
    es: '<p>1. ¿Cómo deben unirse los alumnos a la experiencia?</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data4: {
    es: '<p>El usuario podrá:<br/><br/>a. Unirse a través del PIN de la experiencia.<br/>&emsp; i. El usuario debe entrar en play.smartmakings.com<br/>&emsp; ii. A continuación, se solicitará introducir el pin de la experiencia.<br/>&emsp; iii. Posteriormente, deberá seleccionar su nombre en la lista desplegable.<br/>&emsp; iv. En este punto, el usuario deberá esperar a que el dinamizador ejecute el inicio de la experiencia.<br/><br/>b. Unirse a través del código QR:<br/>&emsp; i.El usuario escaneará el código QR de la experiencia.<br/>&emsp; ii. Posteriormente, deberá seleccionar su nombre en la lista desplegable.<br/>&emsp; iii. En este punto, el usuario deberá esperar a que el dinamizador ejecute el inicio de la experiencia.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data5: {
    es: '<p>2. ¿Hay que impartir todas las sesiones de los itinerarios?</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data6: {
    es: '<p>Consideramos que para conseguir los objetivos fundamentales del itinerario es necesario impartir todas las sesiones del mismo.<br/><br/>En el caso de que por causas de fuerza mayor no puedan impartirse la totalidad de las sesiones, los resultados del informe final del itinerario podrían no reflejar la imagen fiel del aprendizaje obtenido de la misma.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data7: {
    es: '<p>3. ¿Qué sucede si la clase empieza más tarde?</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data8: {
    es: '<p>Ante cualquier imprevisto no deseado, el dinamizador podrá reducir el tiempo destinado a la introducción y, si fuera necesario, al debate hasta compensar el transcurso ordinario de la sesión.<br/><br/>Las fases 2 y 4 de cada sesión están programadas en la aplicación y no pueden tener una duración inferior.<br/><br/>En caso de que el retraso fuera de más de 20 minutos acumulados, recomendamos emplazar la sesión a otra fecha.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data9: {
    es: '<p>4. ¿Qué pasa si, durante la experiencia, el alumno escoge la opción equivocada en una interacción?</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data10: {
    es: '<p>No sucedería nada.<br/><br/>El alumno podría regresar a la ventana de toma de decisión y cambiar su decisión para continuar con el transcurso de la experiencia.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data11: {
    es: '<p>5. ¿Qué sucede si un alumno no puede asistir a todas las sesiones de un itinerario?</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data12: {
    es: '<p>No ocurre nada.<br/><br/>Simplemente los resultados del informe final del itinerario asociado a ese alumno podrían no reflejar la imagen fiel del aprendizaje obtenido de la misma.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data13: {
    es: '<p>6. ¿Quién es el encargado de dinamizar las sesiones?</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data14: {
    es: '<p>El administrador del centro será la persona encargada de asignar los docentes responsables de los diferentes itinerarios que serán implementados en su centro. </p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data15: {
    es: '<p>7. ¿En qué curso y materia encajan mejor el proyecto (Smart)Makings?</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data16: {
    es: '<p>El proyecto de (Smart)Makings está diseñado para jóvenes no menores de 15 años, debido al nivel madurativo que requieren nuestras experiencias.<br/><br/>No tenemos una edad límite para la implementación, ya que las competencias y habilidades que enseñamos son esenciales para el desarrollo profesional y personal del individuo, y cualquier momento es adecuado para adquirirlas si aún no se poseen.<br/><br/>Respecto a la implementación en el centro, ofrecemos total libertad para que la institución encuentre el mejor encaje. Aquí algunas recomendaciones:<br/><br/>- Plan de Acción Tutorial (PAT):<br/>Muchos centros encuentran beneficioso incorporar nuestras experiencias dentro de su Plan de Acción Tutorial. En este contexto, las sesiones de (Smart)Makings pueden complementar las actividades de orientación y desarrollo personal que ya forman parte del PAT, ayudando a los estudiantes a prepararse mejor para los desafíos futuros.<br/><br/>- Currículum Escolar:<br/>Nuestras experiencias pueden ser incorporadas como un componente práctico dentro del currículum escolar. Esto permite integrar las habilidades y competencias que enseñamos con las materias tradicionales, proporcionando a los estudiantes una educación más completa y práctica. Asignaturas como Educación para la Ciudadanía, Formación y Orientación Laboral, o incluso proyectos interdisciplinarios, pueden beneficiarse de nuestra metodología.<br/><br/>- Actividad Extraescolar:<br/>Algunos centros prefieren implementar nuestras experiencias como actividades extraescolares. Esta modalidad ofrece flexibilidad tanto en la programación como en la participación, permitiendo a los estudiantes que estén interesados en desarrollar estas habilidades fuera del horario lectivo. Esto es especialmente útil para aquellos centros que buscan enriquecer su oferta de actividades extracurriculares y brindar a sus alumnos oportunidades adicionales de aprendizaje y crecimiento.<br/><br/>Cada centro puede decidir la mejor forma de incorporar el proyecto de SmartMakings, asegurando que se adapte a sus necesidades y objetivos educativos específicos.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data17: {
    es: '<p>8. Si tengo algún problema técnico y no puedo llevar a cabo la experiencia, ¿qué debo hacer?</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  faqs_data18: {
    es: '<p>Para recibir asistencia técnica, puedes ponerte en contacto con nosotros enviando un correo electrónico a customercare@smartmakings.com o llamando al +34 924 103 227. Nuestro equipo estará encantado de ayudarte a resolver cualquier problema que puedas tener.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
};
